<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close" >
    <v-card>
      <v-card-title class="pt-4">{{ createOrUpdate }} year</v-card-title>
      <v-card-text>
        <FormRHDHV ref="form" url="years" :model="model" :formOrder="order" :dialog="dialog"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormRHDHV from "@/components/form/FormRHDHV.vue";

export default {
  name: "YearDialog",
  components: {FormRHDHV},
  data: () => ({
    model: null,
    loading: false,
    order: [
      'year',
    ],
  }),
  computed: {
    ...mapState('years', {
      base: state => state.base,
      dialog: state => state.dialog,
    }),
    ...mapState('project', {
      currentProject: state => state.currentProject,
    }),
    createOrUpdate() {
      return 'Create'
    }
  },
  watch: {
    dialog() {
      // Required otherwise the form will throw validation errors
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  },
  methods: {
    ...mapActions('years', {
          createItem: "createItem",
          toggleDialog: "toggleDialog"
        }
    ),
    ...mapActions("project", {
      fetchProject: "fetchProject",
    }),
    close() {
      this.$refs.form.resetValidation()
      this.toggleDialog();
    },
    async save() {
      this.loading = true
      let is_valid = this.$refs.form.save()
      this.model.project = this.currentProject.id
      if (is_valid) {
        await this.createItem(this.model)
        await this.fetchProject(this.currentProject.id)
        this.loading=false
        this.close()
      } else {
        console.log('Is not valid')
      }
    },
  },
  mounted() {
    this.model = JSON.parse(JSON.stringify(this.base))
  }
}
</script>

